export default Object.freeze({
  SAVE: 'SAVE',
  APPLY: 'APPLY',
});
